import {useLazyQuery} from "react-apollo";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {CHAT_SERVICE_FLOW_ENABLED} from "shared/constants";
import getOrCreateChatGroupQuery from "../../../../shared/Inbox/queries/getOrCreateChatGroupQuery";

export function useGetOrCreateChatGroup() {
    const isChatServiceFlowEnabled = useBooleanFeatureFlag(
        CHAT_SERVICE_FLOW_ENABLED.key,
        CHAT_SERVICE_FLOW_ENABLED.value,
    );
    const [getOrCreateChatGroup, {data: chatGroupData}] = useLazyQuery(getOrCreateChatGroupQuery);

    if (!isChatServiceFlowEnabled) {
        return {
            getOrCreateChatGroup,
            chatGroupData,
        };
    }

    // todo: Will be removed after V2 logic added
    return {
        getOrCreateChatGroup: () => {
            console.warn("Chat service flow is enabled.");
        },
        chatGroupData: null,
    };
}
